import { Theme, Tray } from '@busybusy/webapp-react-ui';
import { DeleteIcon } from 'assets/icons';
import classNames from 'classnames';
import { ActionBar, IconButton } from 'components';
import DeleteConfirmationDialog from 'containers/photos/DeleteConfirmationDialog/DeleteConfirmationDialog';
import { useOpenable } from 'hooks';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEquipmentInspectionReportActionBarProps {
  className?: ClassName;
  checkedIds: string[];
  onDelete: (ids: string[]) => void;
  unselectAll: (ids: string[]) => void;
}

const EquipmentInspectionReportActionBar = (props: IEquipmentInspectionReportActionBarProps) => {
  const { className, checkedIds, onDelete, unselectAll } = props;

  const deleteConfirmDialog = useOpenable();
  const multipleSelected = checkedIds.length > 1;

  const handleOnClear = () => {
    unselectAll([]);
  };

  const handleDelete = () => {
    deleteConfirmDialog.close();
    onDelete(checkedIds);
  };

  const classes = classNames('equipment-inspection-report-action-bar', className);

  return (
    <>
      <ActionBar selectedCount={checkedIds.length} onClear={handleOnClear} className={classes}>
        <Tray spacing={2}>
          <IconButton
            svg={DeleteIcon}
            onClick={deleteConfirmDialog.open}
            tooltipLabel={t(`Delete selected ${multipleSelected ? 'items' : 'item'}`)}
            theme={Theme.DARK}
          />
        </Tray>
      </ActionBar>
      <DeleteConfirmationDialog
        title={t(`Delete ${multipleSelected ? 'inspections' : 'inspection'}?`)}
        isOpen={deleteConfirmDialog.isOpen}
        onClose={deleteConfirmDialog.close}
        onDelete={handleDelete}
      >
        {t(
          `If you delete ${multipleSelected ? 'these items they' : 'this item it'} will be gone forever. Are you sure you want to proceed?`
        )}
      </DeleteConfirmationDialog>
    </>
  );
};

export default EquipmentInspectionReportActionBar;
